import { z } from "zod";
import { isoDateSchema } from "../utils/dates";
import { idSchema, optionalText } from "./fields";

export const availabilityWindowSchema = z.object({
  id: idSchema,
  boatId: idSchema,
  startDate: isoDateSchema,
  endDate: isoDateSchema,
  note: z.string().optional(),
});
export type AvailabilityWindow = z.infer<typeof availabilityWindowSchema>;

export const newAvailabilityWindowSchema = z
  .object({
    boatId: idSchema,
    startDate: isoDateSchema,
    endDate: isoDateSchema,
    note: optionalText(200),
  })
  .refine((w) => w.endDate >= w.startDate, {
    message: "End date must be on or after the start date.",
    path: ["endDate"],
  });
export type NewAvailabilityWindow = z.infer<typeof newAvailabilityWindowSchema>;
